import { useEffect } from "react";

export default function TestError() {
  useEffect(() => {
    // This will trigger the error boundary
    throw new Error("This is a test error to demonstrate the FallbackComponent");
  }, []);

  return null;
}
